import { useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon";
import { useLocation, useNavigate } from "react-router-dom";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Table from "./Table";
import printerimg from "../../../../assets/print.png"
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import { usePostSubmitGrnMutation, usePostUpdateGrnMutation } from "../../../../store/api/grnapi";
import { useGetDoctypeDetailsQuery } from "../../../../store/api/itemapi";
import { useGetVendorAddressListMutation } from "../../../../store/api/purchaseorderapi";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import Attachment from "../../../../utils/Attachment";
import { RMcurrentGrnId } from "../../../../Localstorage/Localstorage";
import { usePostActiveSNoPutAwayMutation } from "../../../../store/api/putawayapi";
import PrintModal from "../../../../Core/Print/PrintModal";
const PurchaseReciept = ({id = null}) => {
  const nvg = useNavigate();
  const location = useLocation();
  const [activityboll, setactivityboll] = useState(false)
  const PurchaseData = id ? id : location.state?.PurchaseId;
  const [finalstep, setfinalstep] = useState(false);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [tab, settab] = useState(1)
  const [status, setStatus] = useState('');
  const [serialNo_State, setserialNo_State] = useState([]);
  console.log("serialNo_StateserialNo_StateserialNo_State",serialNo_State);
  const [item_Rows, setitem_Rows] = useState([]);
  console.log("item_Rowsitem_Rowsitem_Rowsitem_Rowsitem_Rows",item_Rows);
  // console.log("setitem_Rowssetitem_Rowssetitem_Rows",item_Rows);
  const [ptype, setptype] = useState("Error");
  const [error, setError] = useState('');
  const [showError, setShowError] = useState(false);
  const [vendor, select_vendor] = useState('')
  const [pr_response, setpr_response] = useState("");
  const [vendor_address_list, setvendor_address_list] = useState([]);
  const [select_vendor_address, setselect_vendor_address] = useState({});
  const [itemList, setItemList] = useState([]);
  const [update_grn] = usePostUpdateGrnMutation()
  const [submit_grn] = usePostSubmitGrnMutation()
  const [getvendor_address_list_data] = useGetVendorAddressListMutation();
  const [GetActiveSerialNOPutAway] = usePostActiveSNoPutAwayMutation();
  // console.log("setItemListsetItemListsetItemListsetItemList",itemList);
  const getserialNo = async () =>{
     const response = await GetActiveSerialNOPutAway({"receipt_id":PurchaseData});
    //  console.log("response os response",response);
    //  console.log("response os response dd",response?.data?.result?.items[1]?.serial_no?.split(","));
     setserialNo_State(response?.data?.result?.items);
  }

  useEffect(()=>{
    if(finalstep || status == "To Bill" || status == "Partial Put-Away"){
      getserialNo()
    }
  },[finalstep,status])

  const getVendor_Address = async () => {
    try {
      const vendorAddressApiData = await getvendor_address_list_data({ vendor: vendor })
      setvendor_address_list(vendorAddressApiData.data.result);
      setselect_vendor_address(vendorAddressApiData.data.result?.[0])
    } catch (error) {
      console.log("check error", error)
    }
  }

  const { data: fulldata, isLoading } = useGetDoctypeDetailsQuery({ "doctype": "Purchase Receipt", "name": PurchaseData });
  useEffect(() => {
    if (isLoading == false) {
       setactivityboll(true)
      let updatedRows = fulldata.message.items.map(item => ({
        ...item,
        accepted_qty: item.qty,
        rejected_qty: 0,
        expiry_date: '',
        serial_numbers: item?.serial_no == null ? [] : item.serial_no.split(/\r?\n/).filter(s => s.trim() !== "")
      }));
      setItemList(updatedRows)
       setStatus(fulldata.message.wms_status == null ? fulldata.message.status : fulldata.message.wms_status)
      if (fulldata) {
        select_vendor(fulldata.message.supplier);
      }
    };

  }, [fulldata, isLoading,finalstep,status])


  const UpdatePurchaseOrder = async () => {
    for (const item of item_Rows) {

      let apdQty = itemList.reduce((total, item) => { return total + Number(item?.accepted_qty); }, 0);
      if (apdQty == 0) {
        setptype("Error");
        setError(`At least 1 are required for item ${item.item_code}`);
        setError(`Please ensure at least 1 item is accepted before proceeding.`);
        setShowError(true);
        return;
      }
    }
    
    const payload = {
      grn_id : PurchaseData,
      items : item_Rows.map(item => ({
        item_code : item.item_code,
        qty:Number(item.accepted_qty),
        received_qty : Number(item.accepted_qty),
        serial_nos: item.serial_numbers.slice(0, Number(item.accepted_qty)),
        batch_no: item.batch_no,
        manufacturing_date: item.manufacturing_date,
        expiry_date: item.expiry_date
      })),
      currency: fulldata.message.currency ? fulldata.message.currency : "",
      price_list: fulldata.message.buying_price_list ? fulldata.message.buying_price_list : "",
      cost_center:fulldata.message.cost_center ? fulldata.message.cost_center : "",
      project:fulldata.message.project ? fulldata.message.project : "",
      tax_category: fulldata.message.taxes_and_charges ? fulldata.message.taxes_and_charges : "",
      terms_and_conditions:fulldata.message.tc_name ? fulldata.message.tc_name : ""
    };
    try {

      const ResponseData = await update_grn(payload)

      if (ResponseData.error) {
        setptype("Error")
        setError(ResponseData.error?.data?.message);
        setShowError(true);
      } else {
        setpr_response({"result":ResponseData.data.data})
        setptype("Message")
        setError("GRN Updated Successfully");
        setShowError(true);


        setTimeout(() => {
          setptype("Error")
          setError("");
          setShowError(false);
        }, 4000);
      }


    } catch (error) {
      console.log("error", error);
    }
  }

  const SubmitPurchaseOrder = async () => {

    const payload = {
      receipt_id: PurchaseData
    };
    try {
      const ResponseData = await submit_grn(payload)

      if (ResponseData.error) {
        setptype("Error");
        let message;
        let api_message = ResponseData.error?.data?.exception;
        if(api_message.includes('Batch No is mandatory for Item')){
          message = api_message.substring(api_message.indexOf("Batch"));
          message = message.replace(/<[^>]*>/g, '');
        }else{
          message = api_message.replace('frappe.exceptions.ValidationError: ', '');
          message = message.replace(/<[^>]*>/g, '');
        }
        setError(message);
        setShowError(true);
        return;
      }
      getserialNo();
      setptype("Message");
      setError("GRN Submitted Successfully");
      setShowError(true);
      setfinalstep(true);

      setTimeout(() => {
        setptype("Error");
        setError("");
        setShowError(false);
      }, 4000);


    } catch (error) {
      console.log("error", error);
    }

  }

  useEffect(() => {
    getVendor_Address()
  }, [vendor])


  const redirecttoPutaway = async () =>{
    const response = await GetActiveSerialNOPutAway({"receipt_id":PurchaseData});
     console.log("response os response ffff",response);
     console.log("response os response ffff ddd",item_Rows);
     let itemlist = response?.data?.result?.items;

    //  console.log("response os response ffff ddd ffff",item_Rows.map(item => ({
    //       item_code: item.item_code,
    //       received_qty: Number(item.accepted_qty),
    //       serial_nos: itemlist?.filter(serial_item => serial_item.item_code == item.item_code)[0].unused_serial_no,
    //       batch_no: item?.batch_no,
    //     })));
    RMcurrentGrnId()
    setTimeout(() => {     
      nvg('/inbound/putaway/create-putaway', { state: {Grn:PurchaseData,supplier:fulldata?.message?.supplier,po:fulldata?.message?.items[0].purchase_order,itemwithSerialNo:item_Rows.map(item => ({
          item_code: item.item_code,
          received_qty: Number(item.accepted_qty),
          serial_nos: itemlist?.filter(serial_item => serial_item.item_code == item.item_code)[0].unused_serial_no,
          batch_no: item?.batch_no,
        }))} })


    }, 1000);
  }

  return (

    isLoading ? "" : <>
      <FormLayout
        title={id == null ? "Edit GRN" : "New GRN"}
      breadcrumbs={[
    { label: "Inbound" },
    { label: "GRN List", url: "/inbound/grn/create-grn-receipt" }]}
        status={status}
        finalStep={finalstep}
        actionButtons={
          <>
   {/* {console.log("item_Rowsitem_Rowsitem_Rowsitem_Rows",item_Rows)}
   {console.log("item_Rowsitem_Rowsitem_Rowsitem_Rows 1234567890",item_Rows.map(item => ({
        item_code: item.item_code,
        received_qty: Number(item.accepted_qty),
        serial_nos: item?.serial_no?.split(/[\n\\]+/),
        batch_no: item.batch_no,
      })))}
   {console.log("item_Rowsitem_Rowsitem_Rowsitem_Rows 000000000000000000000000000",item_Rows.map(item => ({
        item_code: item.item_code,
        received_qty: Number(item.accepted_qty),
        serial_nos: serialNo_State?.find(serial_item => serial_item.item_code === item.item_code)?.unused_serial_no,
        batch_no: item.batch_no,
      })))} */}
          <p 
          
          onClick={() => {redirecttoPutaway()}} style={{ backgroundColor: '#fff', textDecoration: 'none', display: finalstep || status == "To Bill" || status == "Partial Put-Away" ? "" : "none" }} className="custom-btn-00989blue m-0">
            + Create Putaway
          </p>


            {status === 'Draft' && (
              <Button
                className="custom-btn-00989"
                onClick={UpdatePurchaseOrder}
                iconName="LuFilePlus2"
                style={{ gap: '2px', height: '28px' }}
                iconSize={12}
                display={finalstep ? 'none' : 'flex'}
              >
               Update
              </Button>
            )}

            {status === 'Draft' && (
              <Button
                className="custom-btn-00989"
                onClick={SubmitPurchaseOrder}
                iconName="LuFilePlus2"
                style={{ gap: '2px', height: '28px' }}
                iconSize={12}
                display={finalstep ? 'none' : 'flex'}
              >
               Submit
              </Button>
            )}
            <p className="p-0 m-0">
                        <img src={printerimg} 
                        onClick={() => setShowPrintModal(true)} 
                         className="px-2" style={{width:'35px',cursor:'pointer'}} alt="404" />
                    </p>
          </>
        }
      ></FormLayout>
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                <a className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                  General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                </a>
              </li>
              <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
                <a className={tab == 2 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(2) }} href="javascript:void(0);">
                  Address & Contact {tab == 2 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                </a>
              </li>
            </ul>
                        <Attachment doctype="Purchase Receipt"  docname={PurchaseData}  /> 
           
          </div>
        </div>
        <div className="row d-flex justify-content-between" style={{ marginTop: '14px',flexGrow:'1' }}>
         {tab != 1 ? "" : <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
            <Tab1 po={{ current_op: PurchaseData }} vendor={{ vendor: vendor }} fulldata={fulldata}  activityboll={activityboll}/>
          </div> } 
        {tab != 1 ? "" : <div className="col-9 d-flex flex-column" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', minHeight: tab == 1 ? "400px" : '0px' }}>
            <div className="d-flex justify-content-between pb-2" style={{ gap: '5px' }}>
              <div className="d-flex" style={{ gap: '5px' }} >
                <p className="NoOfLine">No. of lines - <span style={{ color: '#2563EB' }}> {fulldata?.message?.items?.length}</span></p>
                <p className="TotalQty">Total Quantity -  <span style={{ color: '#16A34A' }}> {fulldata?.message?.total_qty}</span></p>
              </div>
           
            </div>
            <div className="tableLabel">
              <div style={{ width: '99.6%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
              <p style={{ color: "#1E1E1E", fontWeight: '500', marginBottom: '4px' ,fontSize:'15px'}}>
                Item Details
              </p>
            </div>
            <Table
              // list_data={fulldata?.message?.items}
              status={status}
              serialNo_State={serialNo_State}
              list_data={itemList}
              fulldata={fulldata}
              row={{ Rows: item_Rows, setRows: setitem_Rows }} />

            <div className="mt-auto  pb-1" >
              <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
                <div style={{ width: '20%' }}>
                  <p className="TotalQtywithoutBg">
                    Ordered Quantity -
                    <span style={{ color: '#EC642A' }}>
                      {fulldata?.message?.total_qty}
                    </span>
                  </p>
                </div>

                <div style={{ width: '18%' }}>
                  <p className="NoOfLinewithoutBg">
                    Total Value -
                    <span style={{ color: '#FF5969' }}>
                      {fulldata?.message?.total}
                    </span>
                  </p>
                </div>

                <div style={{ width: '24%' }}>
                  <p className="NoOfLinewithoutBg">
                    Tax Type -
                    <span style={{ color: '#C40AB8' }}>
                      {fulldata.message?.taxes.length == 0 ? '' : fulldata.message?.taxes.reduce((acc, curr) => {
                                                                                        if (!acc.includes(curr.description)) {
                                                                                            acc.push(curr.description);
                                                                                        }
                                                                                        return acc;
                                                                                        }, []).join(', ')}
                    </span>
                  </p>
                </div>

                <div style={{ width: '15%' }}>
                  <p className="NoOfLinewithoutBg">
                    Tax -
                    <span style={{ color: '#2563EB' }}>
                      {fulldata?.message?.total_taxes_and_charges}
                    </span>
                  </p>
                </div>

                <div style={{ width: '22%' }}>
                  <p className="NoOfLinewithoutBg">
                    Final Total -
                    <span style={{ color: '#16A34A' }}>
                     {fulldata?.message?.grand_total}
                    </span>
                  </p>
                </div>
              </div>
            </div>
         
          </div>}  
        {tab != 2 ? "" : <div className="col-12" style={{ visibility: tab == 2 ? "visible" : 'hidden', height: tab == 2 ? "auto" : '0px' }}> <Tab2 vendor_address={{ vendor_address_list: vendor_address_list, setselect_vendor_address: setselect_vendor_address, currentAddress: select_vendor_address }} /> </div> }  
          {/* <div className="col-3" style={{ visibility: tab == 3 ? "visible" : 'hidden', height: tab == 3 ? "auto" : '0px' }}> <Tab3 /> </div>  <div className="col-9"> </div> */}
        </div>
      </div>

       {showPrintModal && (
                      <PrintModal 
                          onClose={() => setShowPrintModal(false)}
                          documentId={PurchaseData}
                           doctype="Purchase Receipt"
                          title="Print GRN"
                      />
                  )}



      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </>
  );
};

export default PurchaseReciept;
